/*
  ATD - Testimonials 1
  Carrusel con loop infinito (clonado silencioso) + dots + flechas prev/next.
  Funciona igual en desktop y mobile, simplemente respondiendo al overflow real.
*/
(function () {
  const sections = document.querySelectorAll('.atd-testimonials1');
  if (!sections.length) return;

  sections.forEach((section) => {
    const track = section.querySelector('.atd-testimonials1__track');
    const dots = section.querySelectorAll('.atd-testimonials1__dot');
    const prevBtn = section.querySelector('.atd-testimonials1__arrow--prev');
    const nextBtn = section.querySelector('.atd-testimonials1__arrow--next');
    if (!track) return;

    const originalCount = dots.length || section.querySelectorAll('.atd-testimonials1__card').length;
    let isInfinite = false;

    const isOverflowing = () => track.scrollWidth > track.clientWidth + 1;
    const getCards = () => track.querySelectorAll('.atd-testimonials1__card');

    const setActive = (rawIndex) => {
      if (!dots.length) return;
      const realIndex = ((rawIndex % originalCount) + originalCount) % originalCount;
      dots.forEach((dot, i) => {
        dot.classList.toggle('atd-testimonials1__dot--active', i === realIndex);
        dot.setAttribute('aria-current', i === realIndex ? 'true' : 'false');
      });
    };

    const setupInfinite = () => {
      if (isInfinite) return;
      if (originalCount < 2) return;
      const wrappers = Array.from(track.children);
      wrappers.forEach((w) => {
        const clone = w.cloneNode(true);
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        clone.dataset.clone = '1';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      isInfinite = true;
    };

    const teardownInfinite = () => {
      if (!isInfinite) return;
      track.querySelectorAll('[data-clone]').forEach((el) => el.remove());
      isInfinite = false;
    };

    const getStep = () => {
      const cards = getCards();
      if (cards.length < 2) return 0;
      // Usar la distancia entre dos cards consecutivas (incluye gap)
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    };

    let wrapTimeout = null;
    const scheduleWrapCheck = () => {
      if (!isInfinite) return;
      clearTimeout(wrapTimeout);
      wrapTimeout = setTimeout(() => {
        const step = getStep();
        if (step <= 0) return;
        const idx = Math.round(track.scrollLeft / step);
        if (idx >= originalCount) {
          const prev = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft - originalCount * step;
          void track.offsetHeight;
          track.style.scrollBehavior = prev;
        } else if (idx < 0) {
          const prev = track.style.scrollBehavior;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft + originalCount * step;
          void track.offsetHeight;
          track.style.scrollBehavior = prev;
        }
      }, 200);
    };

    const handleScroll = () => {
      if (!isOverflowing()) return;
      const step = getStep();
      if (step <= 0) return;
      const idx = Math.round(track.scrollLeft / step);
      setActive(idx);
      scheduleWrapCheck();
    };

    let raf = null;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        handleScroll();
      });
    });

    const scrollByCards = (delta) => {
      const step = getStep();
      if (step <= 0) return;
      track.scrollBy({ left: step * delta, behavior: 'smooth' });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCards(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCards(1));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const step = getStep();
        if (step <= 0) return;
        track.scrollTo({ left: step * i, behavior: 'smooth' });
      });
    });

    const resync = () => {
      if (isOverflowing()) {
        setupInfinite();
      } else {
        teardownInfinite();
      }
    };

    resync();
    window.addEventListener('resize', () => {
      clearTimeout(resync._t);
      resync._t = setTimeout(resync, 200);
    });

    setActive(0);
  });
})();
